<div>
  <div class="dia-container-deshabilitado mb-2 mx-2">
    <div
      class="row"
      style="border: 1px solid #0163b9; margin: 0px"
      (click)="openModal(content)"
    >
      <div class="col-12" *ngIf="select">
        <p style="font-size: 15px" class="mb-1">
          <i class="far fa-calendar-alt"></i>
          {{ FECHA.diaSemana }}. {{ FECHA.numeroDia }}-{{ FECHA.mes }}
          <font *ngIf="FECHA.valor > 0" style="font-size: 15px">
            <strong>{{
              FECHA.habilitado ? (FECHA.valor | currency) : ''
            }}</strong>
          </font>
          <font *ngIf="FECHA.valor == 0" style="font-size: 15px"
            ><strong>Gratis</strong></font
          >
        </p>
        <p
          style="color: #0163b9; font-size: 15px; font-weight: bold"
          class="mb-0"
        >
          <i class="fa-solid fa-pen-to-square"></i>
          Cambiar Fecha
        </p>
      </div>

      <div class="col-12" *ngIf="!select">
        <p
          style="
            color: #0163b9;
            font-size: 15px;
            margin-bottom: 0px;
            font-weight: bold;
          "
        >
          <i class="fa-solid fa-pen-to-square"></i>
          Selecciona tu fecha de entrega
        </p>
      </div>
    </div>
  </div>
</div>

<ng-template #content let-c="close" let-d="dismiss">
  <div class="modal-header pull-left">
    <h5 class="modal-title" style="font-size: 16px" id="modal-basic-title">
      <font color="#0063b9"
        ><i
          class="fa-sharp fa-solid fa-circle-check"
          style="margin-right: 10px"
        ></i>
        Seleccione una fecha</font
      >
    </h5>

    <button type="button" class="btn-close" (click)="Close()">
      <!-- <i class="fas fa-times-circle" style="color: #00549d"></i> -->
    </button>
  </div>
  <div class="modal-body">
    <div class="row mb-3">
      <div class="col-2 flex justify-content-center align-items-center">
        <i class="fa-regular fa-circle-info" style="font-size: 20px"></i>
      </div>
      <div class="col-10">
        la información de disponibilidad puede variar durante la compra.
      </div>
    </div>
    <div class="table-responsive overflow-auto">
      <div
        class="dia-container-habilitado row"
        *ngFor="let fecha of semanas[semanaActual].fechas"
        (click)="SeleccionarEnvio(fecha)"
        [ngClass]="
          itemSelectedindex == fecha.index ? 'dia-container-activado' : ''
        "
        style="margin-bottom: 10px; margin-left: 0px"
      >
        <div class="col-2 flex align-items-center justify-content-center">
          <i
            class="fa-sharp fa-solid fa-circle-check"
            style="font-size: 20px"
            [ngStyle]="{
              color: itemSelectedindex == fecha.index ? '#118565' : '#D1D1D1'
            }"
          ></i>
        </div>
        <div
          class="col-4 flex align-items-center justify-content-center text-center"
        >
          <div class="row" style="color: #00549d">
            <div class="col-lg-12" style="font-size: 13px">
              {{ fecha.diaSemana }}. {{ fecha.numeroDia }}-{{ fecha.mes }}
            </div>
            <div
              class="col-lg-12"
              *ngIf="fecha.valor > 0"
              style="font-size: 13px"
            >
              <strong>{{
                fecha.habilitado ? (fecha.valor | currency) : ''
              }}</strong>
            </div>
            <div
              class="col-lg-12"
              *ngIf="fecha.valor == 0"
              style="font-size: 14px"
            >
              <strong>Gratis</strong>
            </div>
          </div>
        </div>
        <div
          class="col-6 flex align-items-center justify-content-center text-center"
        >
          <div class="col-lg-12" style="font-size: 13px">
            Seleccionar fecha
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
